import SelectableSearch from '../../components/SelectableSearch'
import { useDispatch } from 'react-redux'
import { setQueryParam } from './membershipSlice'
import '../../App.scss'
import { create } from '../Radiology/Constants/constants'
import { refactoredData } from './utils'
import { selectableSearchOptions } from './models'
import DropdownMenu from '../../components/DropdownMenu/DropdownMenu'
import { exportExcel } from '../../utils/hooks/Utils'
import { toast } from 'react-toastify'
import { dropDownMenuKeys, noDataMessage } from '../../components/constants'

type Props = {
  onCreate: () => void
  onPremiumCalculate?: () => void
  memberships: any[]
}

const MembershipSearch = ({
  onCreate,
  memberships,
  onPremiumCalculate,
}: Props) => {
  const dispatch = useDispatch()
  const handleSearch = (query: string, param: string) => {
    let q = ''
    switch (query) {
      case 'ID':
        q = 'partner'
        break
      case 'Phone':
        q = 'phone'
        break
      case 'Name':
        q = 'name'
        break
    }

    dispatch(setQueryParam({ q, param }))
  }
  const handleExport = () => {
    if (memberships?.length > 0) {
      exportExcel(refactoredData(memberships))
    } else {
      toast.error(noDataMessage)
    }
  }
  const handleSelect = (e: any) => {
    if (e?.[0] === dropDownMenuKeys?.export) {
      handleExport()
    }
  }

  return (
    <div className='membership-filter'>
      {/* <ExportButton
        data={refactoredData(memberships)}
        disabled={
          !KeycloakService?.hasRole([ADMIN_EXPORT_DATA]) &&
          memberships?.length === 0
        }
      /> */}
      <DropdownMenu
        onSelect={handleSelect}
        filterOptions={[
          {
            label: dropDownMenuKeys?.activeKey,
            value: dropDownMenuKeys?.active,
          },
          {
            label: dropDownMenuKeys?.inActiveKey,
            value: dropDownMenuKeys?.inActive,
          },
        ]}
        actionOptions={[
          {
            label: dropDownMenuKeys?.exportKey,
            value: dropDownMenuKeys?.export,
          },
        ]}
        selectedId={false}
      />
      <SelectableSearch
        items={selectableSearchOptions}
        onSearch={handleSearch}
      />

      <button className='btn btn-primaryBtn' onClick={() => onCreate()}>
        {create}
      </button>
      {onPremiumCalculate && (
        <button
          className='btn btn-primaryBtn'
          onClick={() => onPremiumCalculate?.()}
        >
          Premium Calculator
        </button>
      )}
    </div>
  )
}

export default MembershipSearch
